import { render, staticRenderFns } from "./PropertyList.vue?vue&type=template&id=e74f6a8a&scoped=true"
import script from "./PropertyList.vue?vue&type=script&lang=js"
export * from "./PropertyList.vue?vue&type=script&lang=js"
import style0 from "./PropertyList.vue?vue&type=style&index=0&id=e74f6a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74f6a8a",
  null
  
)

export default component.exports